import { __assign, __rest } from "tslib";
import cx from 'classnames';
import { mapValues } from 'lodash-es';
import PropTypes from 'prop-types';
import React from 'react';
import Label from '../../containers/handoff/Label';
import styles from './Guide.module.css';
export default function Guide(_a) {
    var isVertical = _a.isVertical, zoomScale = _a.zoomScale, value = _a.value, unit = _a.unit, layout = __rest(_a, ["isVertical", "zoomScale", "value", "unit"]);
    var className = cx(styles.guide, {
        'borderWidth-0': true,
        'borderLeftWidth-1': isVertical,
        'borderTopWidth-1': !isVertical,
    });
    var style = mapValues(getStyle(layout, isVertical), function (v) { return zoomScale * v; });
    if (!isVertical) {
        style.top -= 1;
    }
    return (React.createElement("div", { className: className, style: style },
        React.createElement(Label, { guide: style, isGuideVertical: isVertical, unit: unit, value: value })));
}
function getStyle(_a, isVertical) {
    var top = _a.top, left = _a.left, height = _a.height, width = _a.width;
    return __assign({ top: top, left: left }, (isVertical ? { height: height } : { width: width }));
}
Guide.propTypes = {
    isVertical: PropTypes.bool,
    value: PropTypes.number.isRequired,
    zoomScale: PropTypes.number.isRequired,
    unit: PropTypes.string,
    top: PropTypes.number,
    left: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
};
